import React from 'react';

const AuthProvider = ({ children }) => {
  // const navigate = useNavigate();
  // const [isAuthenticated, setIsAuthenticated] = useState(false);

  // useEffect(() => {
  //   const adminInfo = localStorage.getItem('adminInfo');
  //   if (adminInfo) {
  //     setIsAuthenticated(true);
  //   }
  // }, []);

  // useEffect(() => {
  //   if (isAuthenticated) {
  //     navigate('/home');
  //   } else {
  //     // navigate('/login');
  //     return
  //   }
  // }, [isAuthenticated, navigate]);

  return (
    <React.Fragment>
      {children}
    </React.Fragment>
  )
}

export default AuthProvider
